angular.module("groups")

    .controller("GroupsImportGroupCtrl", ['$scope', '$stateParams',
        function ($scope, $stateParams) {
            $scope.groupRows = $stateParams.groupRows;
        }]);